import isEmpty from 'lodash/isEmpty'
import SettingUtils from 'shared/utils/settings'
import { featureEnabled, FeatureFlags } from 'back_office/v2/utils/utils'

export const addressFieldsOrder = () => {
  if (featureEnabled(FeatureFlags.NEW_ADDRESS_VALIDATION)) {
    return ''
  }

  const defaultOrder = SettingUtils.get('address.fields_order')

  if (isEmpty(defaultOrder)) return ''

  const fields = ['first_name', 'last_name', 'country', 'address1', 'address2', ...defaultOrder]

  // Build a string of fields to pass to the AddressFields component.
  // E.g.: "{first_name}\n{last_name}\n{address1}\n{address2}\n{city}\n{country}\n{zipcode}"
  return fields.map((field) => `{${field.replace('region', 'province')}}`).join('\n')
}
